import { IEventBusService } from '@/app-modules/event-bus/event-bus-service';
import { container } from '@/app-modules/_ioc';
import { SERVICE_IDENTIFIERS } from '@/app-modules/_ioc/service-identifiers';
import { ICommandShortcutHandler, ICommandShortcutContext } from '@/components/chat/_domain/modules/command-shortcut-service/command-shortcut-service-interface';
import { getCommandMatches } from '@/components/chat/_domain/modules/command-shortcut-service/handlers/helper';

class OpenSettingsCommandShortcutHandler implements ICommandShortcutHandler {
  private readonly commandMatchRegularExpressions = [/^\/settings/i];

  private get eventBusService(): IEventBusService {
    return container.get(SERVICE_IDENTIFIERS.IEventBusService) as IEventBusService;
  }

  public canProcessCommand(command: string, context: ICommandShortcutContext): boolean {
    const commandMatches = getCommandMatches(command, this.commandMatchRegularExpressions);
    return commandMatches && commandMatches.length === 1;
  }

  public processCommand(command: string, context: ICommandShortcutContext): void {
    if (this.canProcessCommand(command, context)) {
      setImmediate(() => this.eventBusService.getEventBus().$emit('spawnSettingsModal'));
    }
  }
}

export { OpenSettingsCommandShortcutHandler };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/chat/_domain/modules/command-shortcut-service/handlers/open-settings.ts